module.exports = __webpack_public_path__ + "c6b1e81d23ddb864bf074e33e132145d.png";